var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": titleId,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45 44.9",
    ref: svgRef
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "copyTitle"
  }, "Copy") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "copyTitle"
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16,0.1c-3.6,0-6.5,2.9-6.5,6.5v2.8H6.6C3,9.4,0.1,12.4,0.1,16v28.9H29c3.6,0,6.5-2.9,6.5-6.5v-2.8h2.8  c3.6,0,6.5-2.9,6.5-6.5V0.1H16z M33.7,38.3c0,2.6-2.1,4.7-4.7,4.7H2V16c0-2.6,2.1-4.7,4.7-4.7h27.1V38.3z M43,29  c0,2.6-2.1,4.7-4.7,4.7h-2.8V9.4H11.3V6.6C11.3,4.1,13.4,2,16,2H43V29z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/Copy_Icon.3938554935826f44de7b10ac8162517a.svg";
export { ForwardRef as ReactComponent };